export const env = {
    BASE_API_URL: 'https://api.charmy.info',
    BASE_STORAGE_URL: 'http://storage.charmy.info/',
    ENV_NAME: 'prod'
}